import { mergeAttributes } from "@tiptap/core";
import { Image as OriginalImage } from "@tiptap/extension-image";

import type { ImageOptions } from "@tiptap/extension-image";
import type { Node as ProsemirrorNode } from "@tiptap/pm/model";

export const IMAGE_MAX_WIDTH = 720;
export const IMAGE_MIN_WIDTH = 20;

export function clampImageWidth(width: number): number {
  return Math.min(IMAGE_MAX_WIDTH, Math.max(IMAGE_MIN_WIDTH, width));
}

export interface ImageNodeAttrs {
  id: string;
  src: string;
  name: string | null;
  key: string;
  alignment: string;
  width: number;
  height: number;
  sourceUid: string | null;
  sourceType: string | null;
}

export function nodeIsImage(node?: ProsemirrorNode): boolean {
  return node?.type.name === "image";
}

export const Image = OriginalImage.extend<ImageOptions>({
  name: "image",

  addAttributes() {
    return {
      alignment: {
        default: "left",
      },
      key: {
        default: null,
      },
      name: {
        default: null,
      },
      src: {
        default: null,
      },
      width: {
        default: null,
      },
      height: {
        default: null,
      },
      sourceUid: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute("sourceuid") ?? element.getAttribute("sourcedocid"),
      },
      sourceType: {
        default: null,
      },
      tikzSource: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "block-image",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["block-image", mergeAttributes(HTMLAttributes)];
  },
});
